import React, { useEffect, useState } from "react"
import ListTable from "../../molecules/ListTable"
import styled from "styled-components"
import { useGroupList } from "../../../api/admin/group/hooks"
import { Link, useNavigate } from "react-router-dom"
import IconCircle from "../../atoms/IconCircle"
import { useSelector } from "react-redux"

/**
 * 그룹 목록
 * 일반 사용자 & 관리자 공통 화면
 */
const GroupList = () => {
    const navigate = useNavigate()
    const user = useSelector(state => state.auth.user)

    const { data, isLoading, refetch } = useGroupList()
    const groupList = data?.data?.group || []

    const isAdminPage = window.location.pathname.includes('admin')
    const detailPagePathPrefix = isAdminPage ? '/admin' : ''

    useEffect(() => {
        if (data) {
            console.log("@GroupList", groupList);
        }
    }, [data])
    
    return (
        <>
            <Header>
                <h2>그룹 목록 {isAdminPage && <span>(관리)</span>}</h2>

                {user.grade === "2" && (
                    <IconCircle className="bi-plus" onClick={(e) => navigate(`/admin/group/create`)} alt="그룹 생성" />
                )}
            </Header>

            <div>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }} className="center">번호</th>
                            <th style={{ width: "35%" }}>그룹명</th>
                            <th style={{ width: "60%" }}>설명</th>
                        </tr>
                    </thead>

                    <tbody>
                        { groupList?.length > 0
                            ? groupList?.map((el, seq) => {
                                    return (
                                        <tr className="hover-row" key={el.idx} onClick={() => navigate(`${detailPagePathPrefix}/group/detail/${el.idx}`)} 
                                            >
                                            <td className="seq">{seq + 1}</td>
                                            <td >
                                                <Content>{el.name}</Content>
                                            </td>
                                            <td>
                                                <Content>{el.description}</Content>
                                            </td>
                                        </tr>
                                    )
                            })
                            : (
                                <tr className="empty-row">
                                    <td colSpan={3}>
                                        아직 생성된 그룹이 없습니다
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </ListTable>
            </div>
        </>
    )
}

const Content = styled.div`
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export default GroupList
